import { colors } from 'constants/colors';

export const typography = {
  mobileHeadL: {
    fontFamily: 'ZonaPro',
    fontWeight: 800,
    fontSize: '24px',
    lineHeight: '32px',
    color: colors.brown[100],
  },
  mobileHeadM: {
    fontFamily: 'ZonaPro',
    fontWeight: 800,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.brown[100],
  },
  mobileHeadS: {
    fontFamily: 'ZonaPro',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.brown[100],
  },
  mobileHeadLabel: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '20px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: colors.darkGrey[100],
  },
  mobileBodyM: {
    fontFamily: 'ZonaPro',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.lightBrown[100],
  },
  mobileBodyS: {
    fontFamily: 'ZonaPro',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    color: colors.darkGrey[60],
  },
  mobileBodyXS: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '14px',
    color: colors.black.main,
  },
  webHeadL: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '32px',
    color: colors.black.main,
  },
  webHeadS: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '24px',
    color: colors.darkGrey[100],
  },
  webBodyM: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    color: colors.black.main,
  },
  webBodyMDarkRed: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    color: colors.darkRed[100],
  },
  webBodyS: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '24px',
    color: colors.darkGrey[100],
  },
  webCaption: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '16px',
    color: colors.brown[100],
  },
  webInput: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.brown[100],
  },
  webLink: {
    fontFamily: 'ZonaPro',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '14px',
    color: colors.darkRed[100],
  },
  webBodySRegular: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '24px',
    color: colors.darkGrey[80],
  },
  webCaptionBold: {
    fontFamily: 'ZonaPro',
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '24px',
    color: colors.brown[100],
  },
  webCaptionRegular: {
    fontFamily: 'ZonaPro',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '16px',
    color: colors.brown[100],
  },
};
